/**
 * Shared formatters / constants for article sales statistics.
 * Batch table loading was removed — stats load on demand in ArticleSalesStatsDialog.
 */

export const SALES_STATS_DAY_OPTIONS = [7, 14, 30, 90];
export const SALES_STATS_CUSTOM_PERIOD = "custom";
/** All available history (no date window). Sent to API as days=0. */
export const SALES_STATS_ALL_PERIOD = "all";
export const SALES_STATS_ALL_DAYS = 0;
export const SALES_STATS_MAX_DAYS = 365;
/** Otto SPA ad rollups on otto_details cover at most this window. */
export const OTTO_AD_DATA_MAX_DAYS = 90;

export function resolveSalesStatsDays(periodSelect, customDaysInput) {
  if (periodSelect === SALES_STATS_ALL_PERIOD) {
    return SALES_STATS_ALL_DAYS;
  }
  if (periodSelect === SALES_STATS_CUSTOM_PERIOD) {
    const n = parseInt(String(customDaysInput).trim(), 10);
    if (!Number.isFinite(n) || n < 1) return 7;
    return Math.min(n, SALES_STATS_MAX_DAYS);
  }
  return periodSelect;
}

export function resolveSalesStatsWindow({
  periodSelect,
  customDaysInput,
  customFrom,
  customTo,
}) {
  if (periodSelect === SALES_STATS_ALL_PERIOD) {
    return { days: SALES_STATS_ALL_DAYS };
  }
  if (periodSelect === SALES_STATS_CUSTOM_PERIOD && customFrom && customTo) {
    return { from_date: customFrom, to_date: customTo };
  }
  return {
    days: resolveSalesStatsDays(periodSelect, customDaysInput),
  };
}

export function formatSalesStatsPeriodLabel(statsWindow, periodSelect) {
  if (periodSelect === SALES_STATS_ALL_PERIOD || statsWindow?.days === 0) {
    return "All time";
  }
  if (statsWindow?.from_date && statsWindow?.to_date) {
    return `${statsWindow.from_date} → ${statsWindow.to_date}`;
  }
  return `Last ${statsWindow?.days ?? "—"} days`;
}

export function fmtStatsMoney(val) {
  if (val == null || Number.isNaN(Number(val))) return "—";
  return `${Number(val).toFixed(2)} €`;
}

export function fmtStatsPct(val) {
  if (val == null || Number.isNaN(Number(val))) return "—";
  return `${(Number(val) * 100).toFixed(1)}%`;
}

export function fmtStatsQty(val) {
  if (val == null || Number.isNaN(Number(val))) return "—";
  return Number(val).toLocaleString("de-DE", { maximumFractionDigits: 1 });
}
